import { useIntl } from 'react-intl';
import { Tooltip } from '@ets/design-system';

import TOOLBAR_ELEMENTS, {
  Type,
  Structure,
  Symbol,
} from 'Editor/modals/EquationsModal/ToolbarElements';
import ToolbarSection from './ToolbarSection/ToolbarSection';

const ToolbarGroup = ({ type }: { type: Type }) => {
  const intl = useIntl();

  const renderSection = (element: Structure | Symbol) => {
    switch (type) {
      case 'structures':
        return <ToolbarSection element={element as Structure} type="structures" />;
      case 'symbols':
        return <ToolbarSection element={element as Symbol} type="symbols" />;
    }
  };

  return (
    <div className="bg-neutral-5 flex rounded-md shadow-[inset_0_0_0_1px_var(--colors-neutral-20)]">
      {TOOLBAR_ELEMENTS[type].map((element, i) => (
        <Tooltip
          key={element.label}
          content={intl.formatMessage({ id: element.label })}
          testId={`${type}-${i}`}
        >
          <span>{renderSection(element)}</span>
        </Tooltip>
      ))}
    </div>
  );
};

export default ToolbarGroup;
